import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="show" class="loading-container" [class]="containerClass">
      <div class="loading-spinner" [class]="spinnerClass">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <p *ngIf="message" class="loading-message">{{ message }}</p>
    </div>
  `,
  styles: [`
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem;
    }

    .loading-spinner {
      position: relative;
      width: 40px;
      height: 40px;
    }

    .spinner-ring {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 32px;
      height: 32px;
      margin: 4px;
      border: 3px solid #f97316;
      border-radius: 50%;
      animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #f97316 transparent transparent transparent;
    }

    .spinner-ring:nth-child(1) { animation-delay: -0.45s; }
    .spinner-ring:nth-child(2) { animation-delay: -0.3s; }
    .spinner-ring:nth-child(3) { animation-delay: -0.15s; }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .loading-message {
      margin-top: 1rem;
      color: #6b7280;
      font-size: 0.875rem;
    }

    .small .loading-spinner {
      width: 24px;
      height: 24px;
    }

    .small .spinner-ring {
      width: 20px;
      height: 20px;
      margin: 2px;
      border-width: 2px;
    }
  `]
})
export class LoadingSpinnerComponent {
  @Input() show = false;
  @Input() message = '';
  @Input() containerClass = '';
  @Input() spinnerClass = '';
}
